import React from 'react';
import PropTypes from 'prop-types';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  // Slide,
} from '@material-ui/core';

/* const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
}); */

export default function AlertDialog({
  open,
  setOpen,
  title,
  children,
  submitButton,
  cancelButton,
}) {
  const handleSubmitButton = () => {
    if (submitButton) submitButton();

    // setOpen(false);
  };

  const handleClose = () => {
    setOpen(false);
    if (cancelButton) cancelButton();
  };

  // Updated onClose handler to block backdropClick
  const handleDialogClose = (event, reason) => {
    if (reason === 'backdropClick') return;
    handleClose();
  };

  return (
    <Dialog
      open={open}
      // TransitionComponent={Transition}
      onClose={handleDialogClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{title}</DialogTitle>

      <DialogContent>{children}</DialogContent>

      <DialogActions>
        <Button onClick={handleClose} color="primary">
          Fechar
        </Button>
        <Button onClick={handleSubmitButton} color="primary">
          Imprimir
        </Button>
      </DialogActions>
    </Dialog>
  );
}

AlertDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  submitButton: PropTypes.func,
  cancelButton: PropTypes.func,
};

AlertDialog.defaultProps = {
  submitButton: null,
  cancelButton: null,
};
